// The one label drawn above every StyledInput field. `aside` sits at the
// right end of the label row (an info icon, a counter).
const FieldLabel = ({ label, isOptional, aside }) => {
  if (!label && !aside) return null;

  return (
    <div
      className={`ft-sm font-normal text-gray-500 ${
        aside ? 'flex items-center justify-between gap-2' : 'block'
      }`}
    >
      <div className={'flex gap-1'}>
        {label}
        {isOptional && <div className="text-gray-400"> - Optionnel</div>}
      </div>
      {aside}
    </div>
  );
};

export default FieldLabel;
